<template>
  <div>
    <!-- <a-card class="filter-data">
      <span slot="title" style="color: #f60440;">风险预警 ({{ risk_list.length }})
        <a-button type="dashed" @click="recordChange" style="margin-left: 5px;">点击填写</a-button>
        <a-modal v-model="changeVisible" width="1000px" title="请记录" @ok="handleOk">
          <a-textarea v-model="changeInfo" placeholder="请简要概括风险项" allow-clear />
        </a-modal>
      </span>
    </a-card> -->

    <a-card class="filter-data" style="margin-top: 10px;">
      <span slot="title">今日提审单 ({{ workflow_list_today.length }})</span>
      <a-table
        :pagination="false"
        :columns="TotalColumns"
        size="middle"
        :data-source="total_data"
        :loading="loading"
        row-key="workflows_today_number"
      />
      <a-table
        :pagination="false"
        :columns="workflowColumns"
        size="middle"
        :data-source="workflow_list_today"
        :loading="loading"
        row-key="id"
      >
        <span slot="workflowTitle" slot-scope="text, record">
          <a-tooltip placement="top" :title="record.title">
            <a class="workflowTitle" :href="workflowLink(record)" target="_blank">{{ record.title }}</a>
          </a-tooltip>
        </span>
        <span slot="workflowTeam" slot-scope="text, record">
          <a-tooltip v-if="record.workflow_team" placement="top" :title="record.workflow_team">{{ record.workflow_team }}</a-tooltip>
          <span v-else>--</span>
        </span>
        <span slot="qaUsers" slot-scope="text, record">
          <a-tooltip v-if="record.qa_users" placement="top" :title="record.qa_users">{{ record.qa_users }}</a-tooltip>
          <span v-else>--</span>
        </span>
        <span slot="devUsers" slot-scope="text, record">
          <a-tooltip v-if="record.dev_users" placement="top" :title="record.dev_users">{{ record.dev_users }}</a-tooltip>
          <span v-else>--</span>
        </span>
      </a-table>
    </a-card>

    <a-card class="filter-data" style="margin-top: 10px;">
      <span slot="title">未解决Bug ({{ issues.length }}) </span>
      <a-row>
        <a-col :span="12">
          <a-table
            :pagination="pagination"
            :columns="issueColumns"
            size="middle"
            :data-source="issues"
            :loading="loading"
            row-key="id"
          >
            <span slot="issueId" slot-scope="text, record" style="cursor: pointer" @click="onCopy(`BG-${record.id}`)">
              <div v-if="record.is_today" class="corner_issue_unfinished2" />
              <span>{{ `BG-${record.id}` }}</span>
            </span>
            <span slot="issueTitle" slot-scope="text, record">
              <a-tooltip placement="top" :title="record.title">
                <a class="story_title" :href="issueLink(record)" target="_blank">{{ record.title }}</a>
              </a-tooltip>
            </span>
            <span slot="serious" slot-scope="text, record">
              <issue-serious-edit :source-id="record.id" :source-value="record.serious" />
            </span>
          </a-table>
        </a-col>
        <a-col :span="12">
          <issue-summary chart-id="issue-chart-1" :series-data="seriesData" />
        </a-col>
      </a-row>
    </a-card>
  </div>
</template>
<script>
import { getDailyInfo } from '@/api/data/quality';
import { onCopy } from '@/utils/utils';
import IssueSeriousEdit from '@/pages/project/issue/components/IssueSeriousEdit';
import IssueSummary from '@/pages/data/daily/components/IssueSummary';
import dayjs from 'dayjs';

const issueColumns = [
  {
    title: 'ID',
    dataIndex: 'key',
    key: 'id',
    width: '5%',
    ellipsis: true,
    scopedSlots: { customRender: 'issueId' }
  },
  {
    title: '缺陷标题',
    dataIndex: 'title',
    width: '20%',
    ellipsis: true,
    scopedSlots: { customRender: 'issueTitle' }
  },
  {
    title: '缺陷等级',
    key: 'serious',
    width: '5%',
    scopedSlots: { customRender: 'serious' }
  }
];

const columns = [
  {
    dataIndex: 'key',
    key: 'id',
    width: '5%',
    ellipsis: true,
    scopedSlots: { customRender: 'issueId' }
  },
  {
    dataIndex: 'title',
    width: '20%',
    ellipsis: true,
    scopedSlots: { customRender: 'issueTitle' }
  },
  {
    dataIndex: 'title',
    key: 'serious',
    width: '5%',
    scopedSlots: { customRender: 'serious' }
  }
];

const workflowColumns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: '3%',
    ellipsis: true,
    scopedSlots: { customRender: 'workflowId' }
  },
  {
    title: '提审名称',
    dataIndex: 'title',
    width: '15%',
    scopedSlots: { customRender: 'workflowTitle' }
  },
  {
    title: '提审类型',
    width: '7%',
    dataIndex: 'template_name',
    scopedSlots: { customRender: 'templateName' }
  },
  {
    title: '提审时间',
    width: '10%',
    align: 'center',
    customRender: record => {
      return record.created_time;
    },
    sorter: (a, b) => dayjs(a.created_time).diff(dayjs(b.created_time)),
    sortDirections: ['ascend', 'descend']
  },
  {
    title: '提审团队',
    dataIndex: 'workflow_team',
    width: '5%',
    scopedSlots: { customRender: 'workflowTeam' }
  },
  {
    title: '进度',
    width: '5%',
    dataIndex: 'progress',
    align: 'center',
    scopedSlots: { customRender: 'progress' }
  },
  {
    title: '驳回',
    key: 'workflow_releases_reject',
    width: '3%',
    align: 'center',
    customRender: record => {
      return record.workflow_releases_reject;
    },
    sorter: (a, b) => a.workflow_releases_reject - b.workflow_releases_reject,
    sortDirections: ['ascend', 'descend']
  },
  {
    title: '退回',
    key: 'workflow_releases_back',
    width: '3%',
    align: 'center',
    customRender: record => {
      return record.workflow_releases_back;
    },
    sorter: (a, b) => a.workflow_releases_back - b.workflow_releases_back,
    sortDirections: ['ascend', 'descend']
  },
  {
    title: '轮次',
    key: 'workflow_releases_number',
    align: 'center',
    width: '3%',
    customRender: record => {
      return record.workflow_releases_number;
    },
    sorter: (a, b) => a.workflow_releases_number - b.workflow_releases_number,
    sortDirections: ['ascend', 'descend']
  },
  {
    title: '质量',
    key: 'qa_users',
    dataIndex: 'qa_users',
    align: 'center',
    width: '5%',
    scopedSlots: { customRender: 'qaUsers' }
  },
  {
    title: '研发',
    key: 'dev_users',
    dataIndex: 'dev_users',
    align: 'center',
    width: '5%',
    scopedSlots: { customRender: 'devUsers' }
  }
];

const TotalColumns = [
  {
    title: '今日处理流程单总数',
    dataIndex: 'workflows_today_number',
    key: 'workflows_today_number',
    align: 'center',
    width: '6%',
    scopedSlots: { customRender: 'workflowsTodayNumber' }
  },
  {
    title: '今退/驳回提审单总数',
    dataIndex: 'back_reject_str',
    width: '6%',
    align: 'center',
    ellipsis: true,
    scopedSlots: { customRender: 'backRejectNumber' }
  },
  {
    title: '当前未解决缺陷(P0~P3)',
    dataIndex: 'issue_number',
    width: '6%',
    align: 'center',
    ellipsis: true,
    scopedSlots: { customRender: 'issueNumber' }
  },
  {
    title: '今日新增缺陷',
    dataIndex: 'today_new_issue_number',
    width: '6%',
    align: 'center',
    ellipsis: true,
    scopedSlots: { customRender: 'todayNewIssueNumber' }
  },
  {
    title: '今日DONE状态缺陷',
    dataIndex: 'today_done_issue_number',
    width: '6%',
    align: 'center',
    ellipsis: true,
    scopedSlots: { customRender: 'todayDoneIssueNumber' }
  },
  {
    title: '任务交付',
    dataIndex: 'task_number',
    key: 'task_number',
    width: '5%',
    align: 'center',
    scopedSlots: { customRender: 'taskNumber' }
  },
  {
    title: '需求交付',
    dataIndex: 'requirement_number',
    key: 'requirement_number',
    width: '5%',
    align: 'center',
    scopedSlots: { customRender: 'requirementNumber' }
  },
  {
    title: '质量交付',
    dataIndex: 'qa_number',
    key: 'qa_number',
    width: '5%',
    align: 'center',
    scopedSlots: { customRender: 'qaNumber' }
  },
  {
    title: '其他流程',
    dataIndex: 'others_number',
    key: 'others_number',
    width: '5%',
    align: 'center',
    scopedSlots: { customRender: 'othersNumber' }
  }
];

function getIssuesCount(issues, serious) {
  let count = 0;
  issues.forEach(item => {
    if (item.serious === serious) {
      count += 1;
    }
  });
  return count;
}

const PublicFunction = {
  /**
   * 查询当天日期(年-月-日)
   */
  getNowDate() {
    const timeOne = new Date();
    const year = timeOne.getFullYear();
    let month = timeOne.getMonth() + 1;
    let day = timeOne.getDate();
    month = month < 10 ? '0' + month : month;
    day = day < 10 ? '0' + day : day;
    const NOW_MONTHS_AGO = '${year}-${month}-${day}';
    return NOW_MONTHS_AGO;
  }
};

export default {
  components: { IssueSeriousEdit, IssueSummary },
  props: {
    filterForm: {
      // type: Object,
      // default: {
      //   version_id: 1,
      //   user_group: 1
      // }
    }
  },
  data() {
    return {
      loading: false,
      expand: false,
      changeInfo: null,
      risk_list: [],
      issues: [],
      issuesToday: [],
      changeVisible: false,
      workflow_list_today: [],
      total_data: [],
      PublicFunction,
      pagination: {
        size: 'small',
        total: 0,
        pageSize: 50, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      columns,
      issueColumns,
      workflowColumns,
      TotalColumns,
      seriesData: [],
      seriesDataToday: []
    };
  },
  computed: {
    issueLink() {
      return record => {
        return '/project/' + record.project_id + '/quality/issueDetail?issueId=' + record.id;
      };
    },
    workflowLink() {
      return record => {
        return '/project/' + record.project_id + '/workflow/workflowDetail?workflowId=' + record.id;
      };
    }
  },
  mounted() {
    this.getDailyData();
  },
  methods: {
    recordChange() {
      this.changeVisible = true;
    },
    handleOk() {
      modifyChangeInfo({ id: this.storyId, change_info: this.changeInfo })
        .then(() => {
          this.$message.success('记录成功');
        })
        .catch(() => {
          this.loading = false;
        });
      this.changeVisible = false;
    },
    onCopy,
    getDailyData() {
      this.issues = [];
      this.issuesToday = [];
      this.workflow_list_today = [];
      this.total_data = [];
      getDailyInfo(this.filterForm).then(res => {
        this.issues = res.data.issues;
        this.issuesToday = res.data.issues_today;
        this.workflow_list_today = res.data.workflow_list_today;
        this.total_data = res.data.total_data;
        this.risk_list = res.data.total_data;
        this.seriesData = [getIssuesCount(this.issues, 0),
          getIssuesCount(this.issues, 1),
          getIssuesCount(this.issues, 2),
          getIssuesCount(this.issues, 3)];
        this.seriesDataToday = [getIssuesCount(this.issuesToday, 0),
          getIssuesCount(this.issuesToday, 1),
          getIssuesCount(this.issuesToday, 2),
          getIssuesCount(this.issuesToday, 3)];
      });
    },
    getRiskData() {
      this.risk_list = [];
      getRiskInfo(this.filterForm).then(res => {
        this.risk_list = res.data.risk_list;
      });
    }

  }
};
</script>

<style lang="less" scoped>
/deep/ .customer-filter {
  .ant-page-header {
    padding: 0;
  }

  .ant-form-item {
    margin-bottom: 8px;
    display: flex;

    .ant-form-item-control-wrapper {
      flex: 1;
    }
  }

  .filter-right {
    float: right;
    text-align: right;
  }
}

.custom-link {
  color: rgba(0, 0, 0, 0.65);
}

.custom-link:hover {
  color: #1890ff;
}

.edit-point {
  cursor: pointer;
  display: inline-block;
  padding: 0 4px;
  line-height: 22px;
}

.edit-point:hover {
  background-color: #e4e4e4;
}

.task-points {
  font-size: 11px;
  color: #8c95a8;
}

.filter-data {
  /deep/ .ant-card-body {
    padding: 16px;
  }
}

.corner {
  position: relative;
  background: linear-gradient(135deg, rgba(30, 216, 58, 0.4), transparent) #37ec3a;
}

.corner::before {
  position: absolute;
  bottom: -4px;
  left: -8px;
  font-size: 12px;
  height: 16px;
  content: '未填写结束时间';
  border-radius: 2px 2px 2px 0px;
  padding: 2px 4px;
  line-height: 12px;
  color: #fff;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.4), transparent) #FF8433;
  background-blend-mode: soft-light;
}

.corner_reason1 {
  &:extend(.corner);
}

.corner_reason1::before {
  &:extend(.corner::before);
  content: '未填写结束时间';
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.4), transparent) #FF8433;
}

.corner_reason2 {
  &:extend(.corner);
}

.corner_reason2::before {
  &:extend(.corner::before);
  content: '超过迭代完成时间';
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.4), transparent) #ec374d;
}

.corner_reason3 {
  &:extend(.corner);
}

.corner_reason3::before {
  &:extend(.corner::before);
  content: '请及时提审';
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.4), transparent) #ec374d;
}

.corner_issue_unfinished2 {
  &:extend(.corner);
}

.corner_issue_unfinished2::before {
  &:extend(.corner::before);
  content: '今日创建';
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.4), transparent) #0438f4;
}
</style>
